import React, {Component} from 'react';
import {
    CCText,
    Image,
    TouchableWithoutFeedback,
    View,
} from '../../../custom-packages/react-native-components-in-react/react-native-components-in-react';

import TFoodItem from './Translations/TFoodItem';

import AppConfig from '../../../AppConfig';

import DefaultButton, {DarkButton} from '../../../custom-packages/react-button-package/ButtonPackage';
import FoodEditorModal from './FoodEditorModal';
import ImageIcon from "../../../assets/custom-icons/ImageIcon";
import PencilIcon from "../../../assets/custom-icons/PencilIcon";
import ToggleOnIcon from "../../../assets/custom-icons/ToggleOnIcon";
import ToggleOffIcon from "../../../assets/custom-icons/ToggleOffIcon";
import UpgradeModal from "../Subscription/UpgradeModal";
import FoodImage from "./FoodImage";

export default class FoodItem extends Component {
    lastFoodProps = null;

    constructor(props) {
        super(props);

        this.state = {
            food: this.props.item,
            isEditModalOpen: this.props.item.openEditor ? true : false,
            isUpgradeModalOpen: false,
            toggleLoading: false,
            deleted: false,
        };

        this.toggleEditModal = this.toggleEditModal.bind(this);
    }

    shouldComponentUpdate(nextProps, nextState) {
        let shouldUpdate = false;

        if (nextState.toggleLoading != this.state.toggleLoading) {
            shouldUpdate = true;
        } else if (nextState.food.foo_name != this.state.food.foo_name) {
            shouldUpdate = true;
        } else if (nextState.food.foo_description != this.state.food.foo_description) {
            shouldUpdate = true;
        } else if (nextState.food.foo_active != this.state.food.foo_active) {
            shouldUpdate = true;
        } else if (nextState.food.foo_image != this.state.food.foo_image) {
            shouldUpdate = true;
        } else if (nextState.food.foo_image_lq != this.state.food.foo_image_lq) {
            shouldUpdate = true;
        } else if (nextState.deleted != this.state.deleted) {
            shouldUpdate = true;
        } else if (nextState.isEditModalOpen != this.state.isEditModalOpen) {
            shouldUpdate = true;
        } else if (nextState.isEditModalOpen) {
            shouldUpdate = true;
        } else if (nextState.isUpgradeModalOpen != this.state.isUpgradeModalOpen) {
            shouldUpdate = true;
        } else if (nextState.isUpgradeModalOpen) {
            shouldUpdate = true;
        }

        return shouldUpdate;
    }

    componentDidMount() {

    }

    componentWillUnmount() {

    }

    render() {
        if (this.state.deleted) {
            return null;
        }

        return <View className="card-mobile">
            <div className={'card-body'}>
                <View className="row">
                    <View className="col-12 col-md-1 td mobile-margin-bottom">
                        <FoodImage
                            foodID={this.state.food.foo_id}
                            imageLq={this.state.food.foo_image_lq}
                            onImageChanged={(image) => {
                                const food = {...this.state.food};

                                food.foo_image = image;
                                food.foo_image_lq = image;

                                this.setState({
                                    food: food
                                });
                            }}
                        />
                    </View>
                    <View className="col-12 col-md-2 td">
                        <h4 className="title-mobile">
                            {this.state.food.foo_name}
                        </h4>
                    </View>
                    <View className="col-12 col-md-1 td">
                        {this.state.food.totalPrices ?
                            <CCText className={'mobile-margin-bottom'} style={{fontSize: 18}}>
                                {this.state.food.totalPrices}
                            </CCText>
                            :
                            null
                        }
                    </View>
                    <View className="col-12 col-md-4 td">
                        {this.state.food.foo_description ?
                            <CCText className={'mobile-margin-bottom'} style={{fontSize: 18, color: '#666666'}}>
                                {this.state.food.foo_description}
                            </CCText>
                            :
                            null
                        }
                    </View>
                    <View className="col-12 col-md-4 padding-mobile td"
                          style={{justifyContent: 'flex-end', flexDirection: 'row'}}>
                        <DefaultButton
                            loading={this.state.toggleLoading}
                            icon={this.state.food.foo_active ? <ToggleOnIcon size={25}/> : <ToggleOffIcon size={25}/>}
                            text={this.state.food.foo_active ? TFoodItem[AppConfig.lang].ENABLED : TFoodItem[AppConfig.lang].DISABLED}
                            onPress={this.ToggleFood.bind(this, this.state.food)}
                        />
                        <View style={{width: 7}}></View>
                        <DarkButton
                            icon={<PencilIcon size={25} color={'white'}/>}
                            text={TFoodItem[AppConfig.lang].EDIT}
                            onPress={this.toggleEditModal.bind(this)}
                        />
                    </View>
                </View>
            </div>
            <FoodEditorModal
                visible={this.state.isEditModalOpen}
                onRequestClose={this.toggleEditModal.bind(this)}
                id={this.state.food.foo_id}
                onDataChange={({eventData}) => {
                    this.setState({
                        food: eventData
                    })
                }}
            />
            <UpgradeModal
                visible={this.state.isUpgradeModalOpen}
                onRequestClose={() => {
                    this.setState({
                        isUpgradeModalOpen: false
                    })
                }}
                plan={AppConfig.SUB_STANDARD}
            />
        </View>;
    }

    async toggleEditModal() {
        this.setState(
            (prevState) => ({isEditModalOpen: !prevState.isEditModalOpen}),
        );
    }

    async ToggleFood() {
        const food = {...this.state.food};

        food.foo_active = !food.foo_active;

        this.setState({
            toggleLoading: true,
            food: food
        });

        const response = await fetch(AppConfig.URL + "/Food/Toggle/" + this.state.food.foo_id, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.props.Auth.token
            }
        });

        const r = await response.json();

        if (r.success) {

            this.setState({
                toggleLoading: false,
            });
        }
    }

    async DeleteFood() {
        /*Alert.alert(
            TFoodItem[AppConfig.lang].DELETE_FOOD_TITLE,
            TFoodItem[AppConfig.lang].DELETE_FOOD_TEXT,
            [
                {
                    text: TFoodItem[AppConfig.lang].CANCEL,
                    onPress: () => { },
                    style: "cancel"
                },
                {
                    text: TFoodItem[AppConfig.lang].CONFIRM_DELETE_FOOD_TEXT,
                    onPress: async () => {
                        const response = await fetch(AppConfig.URL + "/Food/Delete/" + this.state.food.foo_id, {
                            method: 'GET',
                            headers: {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json',
                                'Authorization': this.props.Auth.token
                            }
                        });

                        const r = await response.json();

                        if (r.success) {
                            this.setState({
                                deleted: true 
                            });
                        }
                    }
                }
            ]
        );*/
    }
}